// extracted by mini-css-extract-plugin
export default {"title":"Inverter_title__UPwS0","header":"Inverter_header__AMPUX","inverter":"Inverter_inverter__3BZg6"};